import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { professionalAction, userActions } from "../../_actions";
import * as XLSX from "xlsx-js-style";
import {
  Drawer,
  Form,
  Select,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Spin,
  DatePicker,
  Button,
  Row,
  Col,
  Space,
} from "antd";
//import { GPSInformationTable } from "./GPSInformationTable";

//import { GPSInfoTableByMasterId } from "./GPSInfoTableByMasterId";
import { LanguageContext } from "../../context/LanguageContext";
import "./GPSInformation.css";
import { roleAction } from "../../_actions/roleby.action.js";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const { Option } = Select;

const { RangePicker } = DatePicker;
let columns = [];
let data = [];
const GPSInformationTable = React.lazy(() =>
  import("./GPSInformationTable.js").then((module) => ({
    default: module.GPSInformationTable,
  }))
);
const GPSInfoTableByMasterId = React.lazy(() =>
  import("./GPSInfoTableByMasterId.js").then((module) => ({
    default: module.GPSInfoTableByMasterId,
  }))
);

// const baseUrl = 'http://localhost:8080/api';
class GPSInformation extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }
  state = {
    loading: false,
    downloadLoding: false,
    tableColumns: [],
    tableData: [],
    gpsInformationList: [],
    filterDate: [],
    countDrawerOpen: false,
    gpsCountList: [],
    gpsCountSelectedName: "",
    report_1_startDate: "",
    report_1_endDate: "",
    report_loader: false,
    report_API_loader: false,
    gpsInformationListSearch: [],
    gpsSearch: false,
    download: "",
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };

  getGpsExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.gpsSearch
      ? this.state.gpsInformationListSearch
      : this.state.gpsInformationList;

    return (
      arrData1?.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("name_of_the_accused")]: data.name,
        [t("police_stations")]: data.districtName,
        [t("user_name")]: data.userName,
        [t("photo")]:
          data.image != "" && data.image != "null" ? "हो" : "नाही",
        [t("gps_location")]: data.latitude
          ? `Latitude: ${data.latitude}, Longitude: ${data.longitude}`
          : "-",
        [t("patrol_time")]: data.lastUpdatedTime
          ? this.getDateFormat(data.lastUpdatedTime)
          : "No Date",
        Counts: data.counts,
        [t("found/not_found")]:
          data.status == 1 ? "आला" : `नाही ${data.statusDetails || ""}`.trim(),
      })) || []
    );
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getGpsExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("accused_patrol_report");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(
          this.state.report_1_startDate,
          this.state.report_1_endDate
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getCity());
    const { user } = this.props;
    if (user && user.cityId && user && user.role === "4") {
      // this.props.dispatch(userActions.getAll(user && user.cityId, 2));
      this.setState({
        loading: true,
      });
      const { newsList, gpsInformationList, user } = this.props;
      this.setState({ report_API_loader: true });
      if (user.role === "4") {
        professionalAction
          .getGPSInformation(user && user.cityId)
          .then((res) => {
            res &&
              res.text().then((text) => {
                this.setState({
                  gpsInformationList: text && JSON.parse(text),
                  report_API_loader: false,
                });
                this.props.dispatch(
                  professionalAction.getGPSInformationSuccess(
                    text && JSON.parse(text)
                  )
                );
              });
          });
      }
    }
    if (user.role === "2") {
      console.log("police station");
      professionalAction
        .getGpsinformationPoliceStation(user && user.id)
        .then((res) => {
          res &&
            res.text().then((text) => {
              this.setState({
                gpsInformationList: text && JSON.parse(text),
                report_API_loader: false,
              });
              this.props.dispatch(
                professionalAction.getGPSInformationSuccess(
                  text && JSON.parse(text)
                )
              );
            });
        });
    }
    if (user.role === "9" || user.role === "10") {
      let obj = {
        districtId: user && user.map_districtId,
      };
      roleAction.getGpsinformationByRole(obj).then((res) => {
        res &&
          res.text().then((text) => {
            this.setState({
              gpsInformationList: text && JSON.parse(text),
              report_API_loader: false,
            });
            this.props.dispatch(
              professionalAction.getGPSInformationSuccess(
                text && JSON.parse(text)
              )
            );
          });
      });
    }
  }

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  onUserFormSave = () => {
    this.userForm.current.onFinish(true);
  };
  onUserFormUpdate = () => {
    this.userForm.current.onFinish(false);
  };
  changePagination = (sorter, filter, value) => {
    if (
      filter &&
      filter.photo &&
      filter &&
      filter.status &&
      filter &&
      filter.userName
    ) {
      if (value.currentDataSource) {
        this.setState({
          gpsInformationList: value.currentDataSource,
        });
      }
    } else if (sorter && sorter && sorter.column) {
      if (value.currentDataSource) {
        this.setState({
          gpsInformationList: value.currentDataSource,
        });
      }
    } else {
      const { newsList, gpsInformationList, user } = this.props;
      this.setState({
        gpsInformationList: gpsInformationList,
      });
    }
  };

  isSameDate(dates) {
    return (
      moment(dates[0]).isSame(dates[1], "day") &&
      moment(dates[0]).isSame(dates[1], "month") &&
      moment(dates[0]).isSame(dates[1], "year")
    );
    /*{
      return true;
    } else {
      return false;
    }*/
  }
  getFormat(date) {
    if (isNaN(date)) {
      return moment(new Date(date).getTime(), "x").format("DD/MM/YY");
    } else {
      return moment(new Date().getTime(), "x").format("DD/MM/YY");
    }
  }

  isSameDateCompareWithData(compareDate, filterDate) {
    // console.log()
    // let d = new Date(compareDate);
    // console.log(moment(d.getTime() + (-5.5 * 60 * 60 * 1000)).format('DD/MM/YY'), 'First');
    // let d1 = new Date(filterDate);
    // console.log(moment(d1.getTime() + (-5.5 * 60 * 60 * 1000)).format('DD/MM/YY'), 'Second');
    if (this.getFormat(compareDate) === this.getFormat(filterDate)) {
      return true;
    }
    return false;
  }

  onFinishDateRangeGPSTable1 = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });
      if (this.isSameDate(dates)) {
        //console.log("same");
        this.setState({
          report_1_startDate: dates[0].toString(),
          report_1_endDate: "",
          download: "",
        });
      } else {
        //console.log("both");
        this.setState({
          report_1_startDate: dates[0].toString(),
          report_1_endDate: dates[1].toString(),
          download: "",
        });
      }
    }
  };

  onFinishDateRangeGPSTable2 = async () => {
    const { user } = this.props;
    const startDate = this.state.report_1_startDate;
    const endDate = this.state.report_1_endDate;
    console.log("date");
    this.setState({
      report1_API_loader: true,
    });

    // professionalAction.getGPSInformation(user && user.cityId).then((res) => {
    //   res && res.text().then(text => {
    //     this.setState({
    //       gpsInformationList: text && JSON.parse(text),
    //       loading: false
    //     })
    //     this.props.dispatch(professionalAction.getGPSInformationSuccess(text && JSON.parse(text)));
    //   })
    // })

    console.log(this.state.gpsInformationList);
    if (!endDate) {
      let temp = _.filter(this.state.gpsInformationList, (o) => {
        //if (this.isSameDateCompareWithData(o.createdAt, startDate)) {
        var startDate1 = moment(startDate).format(moment.HTML5_FMT.DATE); //moment.utc(startDate).unix();
        var matchedDate = moment(o.createdAt).format(moment.HTML5_FMT.DATE); //moment.utc(startDate).unix();
        //console.log(moment(o.gpstimedate).isSame(local));
        if (moment(matchedDate).isSame(startDate1)) {
          return o;
        }
      });
      this.setState({
        gpsInformationListSearch: temp,
        filterDate: [startDate],
        report1_API_loader: false,
        gpsSearch: true,
      });
    } else {
      let temp = _.filter(
        JSON.parse(JSON.stringify(this.state.gpsInformationList)),
        (o) => {
          // console.log(moment(o.gpstimedate).format('YY-MM-DD'))
          // console.log(this.getFormat(dates[0]) >= this.getFormat(o.gpstimedate))
          var startDate1 = moment(startDate).format(moment.HTML5_FMT.DATE); //moment.utc(startDate).unix();
          var endDate1 = moment(endDate).format(moment.HTML5_FMT.DATE);
          var matchedDate = moment(o.createdAt).format(moment.HTML5_FMT.DATE);
          //console.log("sDate",startDate1,"eDate",endDate1,"matchedDate",matchedDate);
          //if (this.getFormat(o.gpstimedate) >= this.getFormat(startDate) && this.getFormat(o.gpstimedate) <=  this.getFormat(endDate)) {
          if (
            moment(matchedDate).isSameOrAfter(startDate1) &&
            moment(o.createdAt).isSameOrBefore(endDate1)
          ) {
            return o;
          }
        }
      );
      console.log("temp", temp);
      this.setState({
        gpsInformationListSearch: temp,
        filterDate: [startDate, endDate],
        report1_API_loader: false,
        gpsSearch: true,
      });
    }
  };

  onFinishDateRangeGPSTable = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });

      if (this.isSameDate(dates)) {
        let temp = _.filter(this.state.gpsInformationList, (o) => {
          if (this.isSameDateCompareWithData(o.gpstimedate, dates[1])) {
            return o;
          }
        });
        this.setState({
          gpsInformationList: temp,
          filterDate: [dates[0]],
        });
      } else {
        let startDate = dates[0].toString();
        let endDate = dates[1].toString();
        let temp = _.filter(
          JSON.parse(JSON.stringify(this.state.gpsInformationList)),
          (o) => {
            // console.log(moment(o.gpstimedate).format('YY-MM-DD'))
            // console.log(this.getFormat(dates[0]) >= this.getFormat(o.gpstimedate))

            //if (this.getFormat(o.gpstimedate) >= this.getFormat(startDate) && this.getFormat(o.gpstimedate) <=  this.getFormat(endDate)) {
            if (
              moment(o.gpstimedate).isSameOrAfter(startDate) &&
              moment(o.gpstimedate).isSameOrBefore(endDate)
            ) {
              return o;
            }
          }
        );
        this.setState({
          gpsInformationList: temp,
          filterDate: [dates[0], dates[1]],
        });
      }
    } else {
      setTimeout(() => {
        const { newsList, gpsInformationList } = this.props;
        this.setState({
          gpsInformationList: gpsInformationList,
          filterDate: [],
        });
      }, 1000);
    }
  };

  onCountSelect = (selectedData) => {
    if (selectedData) {
      professionalAction
        .getActiveAndNonActiveGpsInforByMasterId(selectedData.masterid)
        .then((res) => {
          res &&
            res &&
            res.text().then(async (text) => {
              console.log(JSON.parse(text));
              this.setState({
                countDrawerOpen: true,
                gpsCountList: text && JSON.parse(text),
                gpsCountSelectedName: selectedData,
              });
            });
        });
    }
  };

  onLockTheAddress = (data) => {
    if (data) {
      professionalAction.markAsLockAddress(data).then((res) => {
        if (res && res.status === 200) {
          this.setState({
            countDrawerOpen: false,
            gpsCountList: [],
            gpsCountSelectedName: [],
          });
          if (data.flag) {
            message.success("Locked the address successfully !!!");
          } else {
            message.success("UnLocked the address successfully !!!");
          }
        }
      });
    }
  };

  onCloseCountsDrawer = () => {
    this.setState({
      countDrawerOpen: false,
    });
  };
  // getPDFFile = () => {
  //   let startDate ='';
  //   if(this.state.startDate){
  //     startDate= this.state.startDate;
  //   }else{
  //     let newDate  = new Date();
  //     startDate = newDate.toISOString();
  //     //  startDate = "2021-04-02T14:29:24.630Z";
  //   }
  //   this.setState({
  //     downloadLoding:true
  //   })
  //    axios(`http://localhost:8080/api/criminal/getPdf/${startDate}/${this.state.endDate}`, {
  //           method: 'GET',
  //           responseType: 'blob' //Force to receive data in a Blob Format
  //       })
  //       .then(response => {
  //       //Create a Blob from the PDF Stream
  //           const file = new Blob(
  //             [response.data],
  //             {type: 'application/pdf'});
  //       //Build a URL from the file
  //           const fileURL = URL.createObjectURL(file);
  //       //Open the URL on new Window
  //           window.open(fileURL);
  //           this.setState({
  //             downloadLoding:false
  //           })
  //       })
  //       .catch(error => {
  //           console.log(error);
  //           this.setState({
  //             downloadLoding:false
  //           })
  //       });
  // }
  getDateFormat = (value) => {
    if (value) {
      // return moment(value).format('LLL');
      if (isNaN(value)) {
        return moment(value).format("DD MMM YYYY hh:mm a"); // moment(new Date(value).getTime(), "x").format("LLL")
      } else {
        return moment.unix(value).format("DD MMM YYYY hh:mm a"); // moment(new Date().getTime(), "x").format("LLL")
      }
    }
  };
  download_csv = () => {
    const { t } = this.context;
    var ReportTitle = t("accused_patrol_report");
    var title = t("accused_patrol_report");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const arrData = this.getGpsExportRows();

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_1_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_1_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  render() {
    const { language, t } = this.context;
    const { user, loading } = this.props;
    const requiredKeys = [];
    console.log(
      "gpsInformationListSearch",
      this.state.gpsInformationListSearch,
      this.state.gpsSearch
    );
    let gpsInformationList = this.state.gpsSearch
      ? this.state.gpsInformationListSearch
      : this.state.gpsInformationList;

    if (gpsInformationList && gpsInformationList.length > 0) {
      let columns1 =
        gpsInformationList &&
        gpsInformationList.length &&
        gpsInformationList.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
            SrNo: index + 1,
          };
        });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      let columnList = tableColumns.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
        };
      });
      // columns1.reverse();

      data = columns1;
      columns = columnList;
    } else {
      data = [];
    }
    return (
      <>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <div
              style={{
                padding: "16px 20px",
                borderRadius: "8px 8px 0 0",
                background: "#fff",
                marginBottom: "0",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#262626",
                }}
              >
                {t("accused_patrol_report")}
              </h2>
            </div>
            <PageHeader
              ghost={false}
              onBack={false}
              //title={user && user.userid}
              //subTitle={
              // user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
              //}
              extra={
                [
                  // <Button
                  //   type="primary"
                  //   className="mb-4"
                  //   onClick={this.onOpenCrateUserDrawer}
                  // >
                  //   नवीन जोडा
                  // </Button>,
                ]
              }
            >
              <Descriptions size="small">
                {/*<Descriptions.Item
                  label={user && user.role === "8" ? "State Name" : "City Name"}
                >
                  {user && user.role === "8"
                    ? "महाराष्ट्र"
                    : "महाराष्ट्र" +
                      " " +
                      "( " +
                      this.getCityName(user && user.cityId) +
                      " )"}
                </Descriptions.Item>*/}
                <Descriptions.Item label={t("select_date")}>
                  <RangePicker
                    onChange={(val) => this.onFinishDateRangeGPSTable1(val)}
                    style={{ marginRight: 10 }}
                    inputReadOnly
                    format={"DD/MM/YYYY"}
                  />
                  <Space>
                    <Button
                      key="1"
                      style={{ marginRight: "10px" }}
                      className="modern-button modern-button-success"
                      type="primary"
                      disabled={!this.state.report_1_startDate}
                      onClick={this.onFinishDateRangeGPSTable2}
                    >
                      {t("find")}
                    </Button>

                    {/* <PDFDownloadLink
        document={<MyDocument cols={columns} rows={data}   /> }
        fileName="movielist.pdf"
        style={{
          textDecoration: "none",
        }}
      >
        <Button
          type="primary"
          className="mb-4"
        >
          Download PDF
        </Button>
      </PDFDownloadLink> */}
                    {/* <Button
                    type="primary"
                    className="mb-4"
                    onClick={this.generatePDFDocument}
                    loading={this.state.downloadLoding}
                  >
                    Download PDF
                  </Button> */}
                    <Form>
                      <Form.Item
                        name="condition"
                        rules={[
                          {
                            required: true,
                            message: t("please_select_an_option"),
                          },
                        ]}
                        style={{ marginBottom: 0 }}
                      >
                        <Select
                          value={this.state.download}
                          onChange={(value) =>
                            this.setState({ download: value })
                          }
                          className="download-select-responsive"
                          style={{ width: "120px", marginRight: "10px" }}
                          placeholder={t("please_select_an_option")}
                        >
                          <Option key="excel" value="excel">
                            {t("excel")}
                          </Option>
                          <Option key="pdf" value="pdf">
                            PDF
                          </Option>
                        </Select>
                      </Form.Item>
                    </Form>
                    <Button
                      key="2"
                      type="primary"
                      style={{ minWidth: "100px" }}
                      className="download-button-responsive download-button-success"
                      onClick={() => this.downloadReport()}
                      loading={this.state.downloadLoding}
                      disabled={
                        !this.state.download ||
                        !(this.state.gpsSearch
                          ? this.state.gpsInformationListSearch?.length
                          : this.state.gpsInformationList?.length)
                      }
                    >
                      {t("download")}
                    </Button>
                  </Space>
                </Descriptions.Item>
              </Descriptions>
            </PageHeader>
          </div>

          <Divider />
          <Spin spinning={loading}>
            <div>
              <React.Suspense fallback={<div>Loading...</div>}>
                <GPSInformationTable
                  onNewsStatusChange={this.onNewsStatusChange}
                  data={data}
                  columns={columns}
                  userRole={user}
                  changePagination={this.changePagination}
                  onCountSelect={this.onCountSelect}
                  loading={this.state.report_API_loader}
                ></GPSInformationTable>
              </React.Suspense>
            </div>
          </Spin>
          <Drawer
            title={t("accused_patrol_report")}
            placement="right"
            width={1000}
            closable={true}
            onClose={this.onCloseCountsDrawer}
            visible={this.state.countDrawerOpen}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  type="default"
                  className="mb-4 mr-2"
                  style={{ marginRight: "15px" }}
                  onClick={this.onCloseCountsDrawer}
                >
                  {" "}
                  Cancel{" "}
                </Button>
                {/* <Button type="primary"  className="mb-4"> Save </Button> */}
              </div>
            }
          >
            <React.Suspense fallback={<div>Loading...</div>}>
              <GPSInfoTableByMasterId
                onLockTheAddress={this.onLockTheAddress}
                data={this.state.gpsCountList}
                selected={this.state.gpsCountSelectedName}
              ></GPSInfoTableByMasterId>
            </React.Suspense>
          </Drawer>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { newsList, gpsInformationList, loading } = professionals;
  return {
    user,
    users,
    newsList,
    gpsInformationList,
    professionals,
    loading,
  };
}

const connectedGPSInformation = connect(mapStateToProps)(GPSInformation);
export { connectedGPSInformation as GPSInformation };
